import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";

// Site-wide safety net for the 3DS card return. If GlobalPay ever drops the
// customer somewhere OTHER than /checkout/secure-payment (homepage, anywhere),
// this watcher notices the in-flight card order stashed by Checkout before the
// 3DS handoff, asks the gateway once whether it settled, and if so walks the
// customer to their confirmation page. Silent no-op in every other case.
export const PendingCardWatcher = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/checkout/secure-payment")) return; // return page owns it
    if (location.pathname.startsWith("/order/")) return;
    let pending = null;
    try {
      pending = JSON.parse(localStorage.getItem("pg_pending_card_order") || "null");
    } catch { return; }
    if (!pending?.id || !pending?.order_number) return;
    if (Date.now() - (pending.ts || 0) > 2 * 60 * 60 * 1000) {
      try { localStorage.removeItem("pg_pending_card_order"); } catch { /* noop */ }
      return;
    }
    api.get(`/globalpay/status/${pending.id}`)
      .then(({ data }) => {
        if (data?.payment_status === "paid") {
          try { localStorage.removeItem("pg_pending_card_order"); } catch { /* noop */ }
          toast.success("Your card payment was confirmed.");
          navigate(`/order/${pending.order_number}`);
        } else if (data?.payment_status === "failed") {
          try { localStorage.removeItem("pg_pending_card_order"); } catch { /* noop */ }
        }
        // still pending → leave the record for the return page / next visit
      })
      .catch(() => { /* transient — try again on next page view */ });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return null;
};

export default PendingCardWatcher;
